module.exports = __webpack_public_path__ + "img/pei3.3fbce8d4.png";